import { CodeCompletionCore } from 'antlr4-c3';
import { type Token } from 'antlr4ng';

import { CohortDefinition } from '@verantos-dev/util-cohort-builder-typescript-runtime';

export const getExpectedTokensForTokenStream = (
  cohortBuilderTokens: Token[],
  cohortDefinitionParser: CohortDefinition
) => {
  const codeCompletion = new CodeCompletionCore(cohortDefinitionParser);
  return cohortBuilderTokens.map((token) => {
    const candidates = codeCompletion.collectCandidates(token.tokenIndex).tokens;
    const options: string[] = [];
    for (const candidate of candidates) {
      const candidateDisplayName = cohortDefinitionParser.vocabulary.getDisplayName(candidate[0]);
      candidateDisplayName && options.push(candidateDisplayName);
    }
    return options;
  });
};
